/**
 * SubjectText
 *
 * This component previously rendered the conference name (meeting title)
 * in the top header of the meeting screen. It has been intentionally
 * changed to render nothing so that the meeting title is no longer shown.
 *
 * @returns {null}
 */
const SubjectText = () => null;
export default SubjectText;
